export const getSheetRoot=(ContractTerm,BuyerInfo,SellerInfo)=>{
  const row_0=new Array(9),row_1=new Array(9),row_2=new Array(9),row_3=new Array(9), sheetRoot=new Array()

  //第一行
  for(let i=0;i<=8;i++){
    if(i==0){
      row_0[i]={
        v: '总计金额',
      }
      row_1[i]={
        v: ContractTerm.join('\n'),
      }
      row_2[i]={
        v: '买方',
      }
      row_3[i]={
        v: `单位名称: ${BuyerInfo.name||''}\n单位地址: ${BuyerInfo.registeredAdd||''}\n税号: ${BuyerInfo.businessLicenseNumber||''}\n法定代表人: ${BuyerInfo.LegalPerson||''}\n授权代理人: ${BuyerInfo.AuthorizedAgent||''}\n开户银行: ${BuyerInfo.bankName||''}\n银行帐号: ${BuyerInfo.accountNumber||''}\n电话: ${BuyerInfo.phone||''}\n传真: ${BuyerInfo.Fax||''}`,
      }
    }else if(i==2){
      // row_0[i]={
      //   t: 'n',
      // }
      row_1[i]={
        v: '',
      }
      row_2[i]={
        v: '',
      }
      row_3[i]={
        v: '',
      }
    }else if(i==4){
      row_0[i]={
        v: '',
      }
      row_1[i]={
        v: '',
      }
      row_2[i]={
        v: '卖方',
      }
      row_3[i]={
        v: `单位名称: ${SellerInfo.fullname||''}\n单位地址: ${SellerInfo.registeredAdd||''}\n税号: ${SellerInfo.businessLicenseNumber||''}\n法定代表人: ${SellerInfo.legalRepresentative||''}\n授权代理人: ${SellerInfo.AuthorizedAgent||''}\n开户银行: ${SellerInfo.bankName||''}\n银行帐号: ${SellerInfo.accountNumber||''}\n电话: ${SellerInfo.phone||''}\n传真: ${SellerInfo.Fax||''}`,
      }
    }else{
      row_0[i]={
        v: '',
      }
      row_1[i]={
        v: '',
      }
      row_2[i]={
        v: '',
      }
      row_3[i]={
        v: '',
      }
    }
  }
  sheetRoot.unshift(row_3)
  sheetRoot.unshift(row_2)
  sheetRoot.unshift(row_1)
  sheetRoot.unshift(row_0)

  return sheetRoot
}
